export const footerObj = {
  linkedIn: require("../../images/socialLogos/LI-In-Bug.png"),
  github: require("../../images/socialLogos/github-mark.png"),
}